/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 主播任务主页  http://wiki.xunlei.cn/pages/viewpage.action?pageId=91711667
export const getInfo = createAsyncThunk(
  'AnchorTaskSystem/getInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/anchor_task_home', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 公会领取等级目标领取奖励接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=91711672
export const receiveIncome = createAsyncThunk(
  'AnchorTaskSystem/receiveIncome',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/anchor_task_receive_income', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 1：未解锁 2：可领取 3：已领取
export enum DrawStatus {
  notAvailable = 0,
  available = 1,
  received = 2,
}

export interface AnchorTaskItem {
  task_level: number
  start: number
  end: number
  cur_income: number
  diff_income: number
  reward: number
  status: DrawStatus
  special_rewards: [{url: string; desc: string}]
  is_show_reward: boolean
  is_show_special_rewards: boolean
}

const initialState: {
  member_info: {
    id: number
    zy_id: number
    name: string
    avatar: string
  }
  diamond: number
  effective_day: number
  union_task_url: string
  count_down: number
  income_list: Array<AnchorTaskItem>
  income_index: number
} = {
  member_info: {
    id: 0,
    zy_id: 0,
    name: '',
    avatar: '',
  },
  diamond: 0,
  effective_day: 0,
  union_task_url: '',
  count_down: 0,
  income_list: [
    // {
    //   task_level: 1,
    //   start: 0,
    //   end: 15000,
    //   cur_income: 2222,
    //   diff_income: 89,
    //   reward: 48000,
    //   status: DrawStatus.notAvailable,
    // },
    // {
    //   task_level: 2,
    //   start: 0,
    //   end: 35000,
    //   cur_income: 3453,
    //   diff_income: 455,
    //   reward: 23454,
    //   status: DrawStatus.received,
    // },
  ],
  income_index: 0,
}

export const AnchorTaskSystemSlice = createSlice({
  name: 'AnchorTaskSystem',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})

export default AnchorTaskSystemSlice.reducer
